// extracted by mini-css-extract-plugin
export default {"modalWrapper":"Modal_modalWrapper__ZSORB"};